import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup, Dropdown, Table, Checkbox, Input, List, Image, Divider, Header, Icon, Message, Accordion, Container, GridColumn, Select } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TimeSheetStore from "../../../app/stores/timesheetStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const TimeSheetApproveForm: React.FC = () => {
  const timesheetStore = useContext(TimeSheetStore);
  const {
    submitting,
    loadPayrollCycles,
    payrollcyclesByName,
    payrollcycleRegistry,
    loadApproveTimeSheets,
    timesheetsByDate,
    editTimeSheets,
    loadEmployees,
    payrunstatusByDate,
    employeeByName,
    selectPayRun,
    selectEmployee,
    employeestatusRegistry,
    payrunweekRegistry,
    employeeRegistry,
    payrunsheetByDate,
    updateRemarkApprove,
    loadProjectTimes,
    projecttimeRegistry,
    clearPage,
    target,
  } = timesheetStore;

  const [selectedPayrun, setSelectedPayrun] = useState('');
  const [activeIndex, setActiveIndex] = useState('');

  useEffect(() => {
    loadPayrollCycles().then(() => loadEmployees()).then(() => loadProjectTimes()).then(
      ()=> loadApproveTimeSheets()).then((pay)=>setSelectedPayrun(pay));
    return () => {
      clearPage();
    };
  }, []);

  if (timesheetStore.loadingInitial)
    return <LoadingComponent content="Loading time sheet..." />;
    
  const payrunstatusOptions = payrunstatusByDate.map(function (pay) {
    var option = { "key": pay.payRun, 
                  "text": <div> <strong>{pay.payRun}</strong>&nbsp;&nbsp;({pay.financeYear})</div>, 
                  "value": pay.financeYear + '-' + pay.payRun }
    return option;
  }
  );

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  function addDays(myDate: string, days: number) {
    return new Date(new Date(myDate).getTime() + days*24*60*60*1000).toISOString().substr(0, 10);
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  function totalDays(email: string) {
    let total = 0;
    if (email)
    {
      payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email
        ).map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.fullDay);                  
      })
    }
    else
    {
      payrunsheetByDate.map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.fullDay);                
      })
    }
    return total;
  } 

  function getReviewer(email: string) {
    const sheets = payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email);
    let reviewer = sheets.length === 0 ? '' : employeeRegistry.get(sheets[0].reviewerEmail).name;
    return reviewer;
  } 

  function getApprover() {
    let approvedCount = 0;
    const status = Array.from(employeestatusRegistry.values());
      status.map((stat) => {
      if (stat === 'Approved') approvedCount = approvedCount + 1;                  
  })
    return approvedCount + ' out of ' + status.length;
  } 

  const handleTitleClick = (e: any, titleProps: any) => {
     const { active, index } = titleProps;
     const newIndex = activeIndex === index ? '' : index
     setActiveIndex(newIndex); 
  }

  function totalWorkingHours(email: string) {
    let total = 0;
    if (email)
    {
      payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email
        ).map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.workingHours);                   
      })
    }
    else
    {
      payrunsheetByDate.map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.workingHours);                  
      })
    }
    return total;
  }; 

  function totalOvertimeHours(email: string) {
    let total = 0;
    if (email)
    {
      payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email
        ).map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.overtimeHours);                   
      })
    }
    else
    {
      payrunsheetByDate.map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.overtimeHours);                  
      })
    }
    return total;
  }; 

  function totalAdjustOvertimeHours(email: string) {
    let total = 0;
    if (email)
    {
      payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email
        ).map((time) => {
          if (time.attendant === 'Y') 
          {
            var rate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).penaltyRate : 1
            total = total + (Number(time.overtimeHours) * Number(rate));  
          }                   
      })
    }
    else
    {
      payrunsheetByDate.map((time) => {
        if (time.attendant === 'Y') 
        {
          var rate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).penaltyRate : 1
          total = total + (Number(time.overtimeHours) * Number(rate));  
        }                
      })
    }
    return total;
  }; 

  function totalWeekendHours(email: string) {
    let total = 0;
    if (email)
    {
      payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email
        ).map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.weekendHours) + Number(time.nightHours);                   
      })
    }
    else
    {
      payrunsheetByDate.map((time) => {
          if (time.attendant === 'Y') total = total + Number(time.weekendHours) + Number(time.nightHours);                  
      })
    }
    return total;
  }; 

  function totalAdjustWeekendHours(email: string) {
    let total = 0;
    if (email)
    {
      payrunsheetByDate.filter((timeSheet) => timeSheet.employeeEmail === email
        ).map((time) => {
          if (time.attendant === 'Y') 
          {
            var weekendRate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).weekendRate : 1
            var nightRate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).nightRate : 1
            total = total + (Number(time.weekendHours) * Number(weekendRate)) + (Number(time.nightHours) * Number(nightRate));  
          }                   
      })
    }
    else
    {
      payrunsheetByDate.map((time) => {
        if (time.attendant === 'Y') 
        {
          var weekendRate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).weekendRate : 1
          var nightRate = (projecttimeRegistry.get(time.projectType)) ? projecttimeRegistry.get(time.projectType).nightRate : 1
          total = total + (Number(time.weekendHours) * Number(weekendRate)) + (Number(time.nightHours) * Number(nightRate));  
        }                
      })
    }
    return total;
  }; 

  return (
    <Segment clearing>
        <Grid columns={2}>
          <Grid.Column width='4'>
          <Select 
            placeholder='Select Pay Run'
            options={payrunstatusOptions} 
            onChange={(e, {value}) => selectPayRun(String(value)).then(() => setSelectedPayrun(String(value)))} 
            value={selectedPayrun}
          />
          </Grid.Column>
          <Grid.Column>
            <List>
              <List.Item style={{color: 'gold', fontWeight: 'bold'}}> {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 1: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 6))}
              </List.Item>
              <List.Item style={{color: 'limegreen', fontWeight: 'bold'}}>
                 {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 2: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 7)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 13))}
              </List.Item>
            </List>
          </Grid.Column>
        </Grid>
        <br/>
        <br/>
    <Grid style={{backgroundColor: '#f9fafb', marginBottom: '1rem'}}>
    <Grid.Column width='14'>
    <Grid>
      <Grid.Column width='5'>
           <h4> Name</h4>
      </Grid.Column>
       <Grid.Column width='2'>
       <h4> Total days</h4>
      </Grid.Column>
      <Grid.Column width='2'>
       <h4> Total working hours</h4>
      </Grid.Column>
      <Grid.Column width='3'>
       <h4> Total time-in-lieu hours</h4>
      </Grid.Column>
      <Grid.Column width='4'>
       <h4> Reviewed by</h4>
      </Grid.Column>
      </Grid>
      </Grid.Column>
      <Grid.Column width='2'>
       <h4> Actions</h4>
      </Grid.Column>
    </Grid>
    {/* <Accordion
        fluid={true}
        // as={Table.Body}
        exclusive={false}
        panels={employeeByName.map(emp => {
            return {
                key: emp.id,
                title: {
                  // as: Table.Row,
                  children: (
                  <Grid>
                    <Grid.Column width='4'>
                    <Icon name='dropdown' />{employeeRegistry.get(emp.email).name}
                    </Grid.Column>
                    <Grid.Column width='2'>
                     {totalDays(emp.email)}
                    </Grid.Column>
                    <Grid.Column width='3'>
                     {offHours(emp.email).toFixed(2)}
                    </Grid.Column>
                    <Grid.Column width='4'>
                     {getReviewer(emp.email)}
                    </Grid.Column>
                    <Grid.Column width='3'>
                    <Button
          loading={target === 'Approved' && submitting}
          floated='left'
          color='green'
          size='mini'
          content='Apporve'
          onClick={() => editTimeSheets(payrunsheetByDate[0].payRun, emp.email, 'Approved', remark)}
          disabled={(payrunsheetByDate.filter((timeSheet) =>
            timeSheet.employeeEmail === emp.email
             ).length === 0)}
     />
                    <Button
          loading={target === 'Rejected' && submitting}
          floated='left'
          color='red'
          size='mini'
          content='Reject'
          onClick={() => editTimeSheets(payrunsheetByDate[0].payRun, emp.email, 'Rejected', remark)}
          disabled={(payrunsheetByDate.filter((timeSheet) =>
            timeSheet.employeeEmail === emp.email
             ).length === 0)}
     />
     
                    </Grid.Column>
                  </Grid>
                  )
                },
                content: {
                    content: (<Table celled>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>Date</Table.HeaderCell>
                          <Table.HeaderCell>Project</Table.HeaderCell>
                          <Table.HeaderCell >Site</Table.HeaderCell>
                          <Table.HeaderCell>Time-off &#40;hours&#41;</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                  
                      <Table.Body>
                      {payrunsheetByDate.filter((timeSheet) =>
                       timeSheet.employeeEmail === emp.email
                        ).map((time, index) => (
                          (time.attendant === 'Y') &&
                        <Table.Row key={time.id}>
                          <Table.Cell width='3'
                          style={{backgroundColor: (index < 7)
                             ? 'yellow' : 'lightgreen'}}>
                            <strong >{convertDate(time.attendanceDate)}</strong>
                            <p>{getDayOfWeek(time.attendanceDate)}</p>
                          </Table.Cell>
                          <Table.Cell>
                            {time.projectType}
                          </Table.Cell>
                          <Table.Cell>
                            {time.site}
                          </Table.Cell>
                          <Table.Cell>
                             {time.weekendHours}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                      </Table.Body>
                    </Table>)
                }
            };
        })}
    /> */}
    
    {employeeByName.map(emp => (
      <div>        
          <Grid>
            <Grid.Column width='14' style={{paddingTop: '1px', paddingBottom: '1px'}}>
            <Accordion>
          <Accordion.Title 
                      onClick={handleTitleClick} 
                      index={emp.email}
                      active={activeIndex === emp.email}
                    >
                      <Grid style={{fontSize: '15px', 
                      color: (employeestatusRegistry.get(emp.email) === 'Approved') ? 'green'
                        : (employeestatusRegistry.get(emp.email) === 'Rejected') ? 'red'
                        : 'grey'}}>
                    <Grid.Column width='5'>
                    
                    <Icon name='dropdown' />
                    <Image avatar src={emp.photoUrl || "/assets/user.png"}/>
                <strong>
                  {emp.name}{emp.preferredName !== "" ? `  (${emp.preferredName})` : ""}</strong>
                  &nbsp;&nbsp;-&nbsp;&nbsp;
                  <i>
                    {employeestatusRegistry.get(emp.email)}</i>
                    </Grid.Column>
                    <Grid.Column width='2' verticalAlign='middle'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{totalDays(emp.email)}
                    </Grid.Column>
                    <Grid.Column width='2' verticalAlign='middle'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{totalWorkingHours(emp.email).toFixed(2)}
                    </Grid.Column>
                    <Grid.Column width='3' verticalAlign='middle'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {(totalAdjustOvertimeHours(emp.email)+totalAdjustWeekendHours(emp.email)).toFixed(2)}
                    </Grid.Column>
                    <Grid.Column width='4' verticalAlign='middle'>
                     {getReviewer(emp.email)}
                    </Grid.Column>
                    </Grid>
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === emp.email}>
                    <Table celled compact='very'>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>Date</Table.HeaderCell>
                          <Table.HeaderCell>Project</Table.HeaderCell>
                          <Table.HeaderCell>Day</Table.HeaderCell>
                          <Table.HeaderCell>Site</Table.HeaderCell>
                          <Table.HeaderCell>
                             <div>Onsite</div>
                             <div>Time</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                             <div>Offsite</div>
                             <div>Time</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                             <div>Working</div>
                             <div>Hours</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                             <div>Overtime</div>
                             <div>Hours</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                             <div>Overtime</div>
                             <div>Rate</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                            <div>Night/</div>
                             <div>Weekend</div>
                             <div>Hours</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                             <div>Night/</div>
                             <div>Weekend</div>
                             <div>Rate</div>
                          </Table.HeaderCell>
                          <Table.HeaderCell >LAHFA</Table.HeaderCell>
                          <Table.HeaderCell >Remark</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                      {payrunsheetByDate.filter((timeSheet) =>
                       timeSheet.employeeEmail === emp.email
                        ).map((time, index) => (
                          (time.attendant === 'Y') &&
                        <Table.Row key={time.id}>
                          <Table.Cell width='1'
                          style={{backgroundColor: (index < 7)
                             ? 'yellow' : 'lightgreen'}}>
                            <strong >{convertDate(time.attendanceDate)}</strong>
                            <p>{getDayOfWeek(time.attendanceDate)}</p>
                          </Table.Cell>
                          <Table.Cell width='2'>
                            {time.projectType}
                          </Table.Cell>
                          <Table.Cell width='1'>
                             {time.fullDay}
                          </Table.Cell>
                          <Table.Cell>
                            {time.site}
                          </Table.Cell>
                          <Table.Cell width='1'>
                             {time.onsiteTime}
                          </Table.Cell>
                          <Table.Cell width='1'>
                             {time.offsiteTime}
                          </Table.Cell>
                          <Table.Cell width='1'>
                             {time.workingHours}
                          </Table.Cell>
                          <Table.Cell width='1'>
                             {time.overtimeHours}
                          </Table.Cell>
                          <Table.Cell width='1'>
                            {(projecttimeRegistry.get(time.projectType)) && 
                              projecttimeRegistry.get(time.projectType).penaltyRate}
                          </Table.Cell>
                          <Table.Cell width='1'>
                          {(getDayOfWeek(time.attendanceDate) === 'Saturday' || 
                  getDayOfWeek(time.attendanceDate) === 'Sunday') ? time.weekendHours : time.nightHours}
                          </Table.Cell>
                          <Table.Cell width='1'>
                            {(getDayOfWeek(time.attendanceDate) === 'Saturday' || 
                  getDayOfWeek(time.attendanceDate) === 'Sunday') ?
                            (projecttimeRegistry.get(time.projectType)) && 
                              projecttimeRegistry.get(time.projectType).weekendRate :
                              (projecttimeRegistry.get(time.projectType)) && 
                              projecttimeRegistry.get(time.projectType).nightRate }
                          </Table.Cell>
                          <Table.Cell width='1'>
                             {time.lahfa}
                          </Table.Cell>
                          <Table.Cell>
                          <Form.Input 
                           transparent
                           placeholder='Input remark here' 
                           name='remark'
                           onChange={(e, {name, value}) => updateRemarkApprove(time.id, value)}
                           value={time.remark}
                          />
                          </Table.Cell>
                        </Table.Row>
                      ))}
                      </Table.Body>
                      <Table.Footer>
        <Table.Row>
      <Table.HeaderCell><strong>Total:</strong>
      </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalDays(emp.email)}</strong>
         </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalWorkingHours(emp.email).toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalOvertimeHours(emp.email).toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalAdjustOvertimeHours(emp.email).toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalWeekendHours(emp.email).toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell><strong>{totalAdjustWeekendHours(emp.email).toFixed(2)}</strong>
          </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
        <Table.Row>
      <Table.HeaderCell><strong>Total All:</strong>
      </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalDays(emp.email)}</strong> days
         </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell><strong>{totalWorkingHours(emp.email).toFixed(2)}</strong> hours
          </Table.HeaderCell>
          <Table.HeaderCell  colSpan='4'>
             Time in lieu: <strong>{(totalAdjustOvertimeHours(emp.email)+totalAdjustWeekendHours(emp.email)).toFixed(2)}</strong> hours
          </Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
                    </Table>
        </Accordion.Content>
        </Accordion>
        </Grid.Column>
                    <Grid.Column width='2' style={{paddingTop: '1px', paddingBottom: '1px',
                   marginTop: '8px'}}>
         <Button
          loading={target === 'Approved'+emp.email && submitting}
          floated='left'
          color='green'
          size='mini'
          content='Apporve'
          onClick={() => editTimeSheets(payrunsheetByDate[0].payRun, emp.email, 'Approved')}
          disabled={(employeestatusRegistry.get(emp.email) === 'Approved')}
        />
         <Button
          loading={target === 'Rejected'+emp.email && submitting}
          floated='left'
          color='red'
          size='mini'
          content='Reject'
          onClick={() => editTimeSheets(payrunsheetByDate[0].payRun, emp.email, 'Rejected')}
          disabled={(employeestatusRegistry.get(emp.email) === 'Rejected')}
         />
                    </Grid.Column>
                  </Grid>
                  <Divider/>
                  </div>
    ))}

    <Grid style={{backgroundColor: '#f9fafb', marginBottom: '1rem'}}>
    <Grid.Column width='14'>
    <Grid>
      <Grid.Column width='5'>
           <h4> All Total:</h4>
      </Grid.Column>
       <Grid.Column width='2'>
       <h4> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{totalDays('')} days</h4>
      </Grid.Column>
      <Grid.Column width='2'>
       <h4> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{totalWorkingHours('').toFixed(2)} hours</h4>
      </Grid.Column>
      <Grid.Column width='4'>
       <h4> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
         {(totalAdjustOvertimeHours('')+totalAdjustWeekendHours('')).toFixed(2)} time-in-lieu hours</h4>
      </Grid.Column>
      <Grid.Column width='3'>
          {/* <h4> {getApprover()} approved</h4> */}
      </Grid.Column>
      </Grid>
      </Grid.Column>
      <Grid.Column width='2'>
       <h4> {getApprover()} approved</h4>
      </Grid.Column>
    </Grid>
    </Segment>
  );
};

export default observer(TimeSheetApproveForm);
